var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flow-ball",style:(_vm.styles)},[_c('div',{class:{ point1: _vm.dir == 1, point2: _vm.dir==2, point3: _vm.dir==3, point4: _vm.dir==4, point5: _vm.dir==5, point6: _vm.dir==6, point7: _vm.dir==7, point8: _vm.dir==8 }})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b03a54c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/svolt/project/components/nanwang/flow-ball.vue
// module id = null
// module chunks = 